import React, { useEffect } from 'react';
import { Button, Radio } from 'antd';

import { CustomImage, Text, useText } from '@src/components';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';

import {
    getBankImagesList,
    getInstantRemittanceBankImagesList,
    setCurrentBank,
} from '@src/store/slice/bankSlice';

import iconAt from '@src/assets/icons/icon-dikkat.svg';
import PropTypes from 'prop-types';

import '@src/styles/autoUploadInstruction/wireTransferCars.scss';

const EftWireTransferCardsUI = ({ finishPage, type, onContinue }) => {
    const isMobil = useMediaQuery({ query: '(max-width: 1199.98px)' });

    const dispatch = useDispatch();

    const { bankList, currentBank } = useSelector((state) => state?.bank);
    const { customerVou } = useSelector((state) => state?.customer);

    const copyText = useText('copy');
    const copiedText = useText('copied');

    useEffect(() => {
        if (customerVou?.patName !== 'Kredili') {
            dispatch(setCurrentBank('paymentLater'));
        }
    }, [customerVou, dispatch]);

    const onChange = async (e) => {
        const item = e.target.value;
        await dispatch(setCurrentBank(item));
    };

    const onClickCopy = (e, copiedValue) => {
        const val = copiedValue.replaceAll('-', '');

        navigator.clipboard.writeText(val);
        e.target.parentElement.parentElement.parentElement.classList.add('copied-box');

        setTimeout(() => {
            e.target.parentElement.parentElement.parentElement.classList.remove('copied-box');
        }, 500);
    };

    useEffect(() => {
        dispatch(getBankImagesList());
        dispatch(getInstantRemittanceBankImagesList());
    }, [dispatch]);

    return (
        <>
            {!finishPage && (
                <>
                    <div className="autoUploadInstruction-wire-transfer-card">
                        <div
                            className="custom-card-body"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                            }}
                        >
                            <CustomImage
                                src={iconAt}
                                style={{
                                    marginTop: '24px',
                                    width: '63.6px',
                                    height: '58px',
                                    objectFit: 'contain',
                                }}
                            />
                            <div className={'custom-alert-warning'}>
                                <div className={'alert-message-contain'}>
                                    <span className={'description'}>
                                        <Text t="afterPressingTheContinueButtonAndCompletingYour" />
                                        <br />
                                        <br />
                                        <Text t="onTheNextTransactionResultPageYouWill" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!isMobil && (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                marginBottom: '24px',
                            }}
                        >
                            <Button
                                id="balanceUpload-payment-eftWireTransferCards-payment-btn"
                                onClick={onContinue}
                                className="payment-btn"
                            >
                                <Text t="continue" />
                            </Button>
                        </div>
                    )}
                </>
            )}
            <span className="custom-card-group-title">
                <Text t="ourAccountNumbersWhereYouCanMakePayment" />
            </span>
            <div className="autoUploadInstruction-wire-transfer-card">
                <div className="custom-card-header">
                    <div className="title">
                        <Text t="paymentByInstantTransfer" />
                    </div>
                </div>

                <div className="custom-card-body">
                    <Radio.Group
                        id="ticketRestaurant-balanceUpload-payment-eftWireTransferCards-custom-radioGroup-input-wire-transfer"
                        value={currentBank}
                        onChange={onChange}
                        defaultValue="paymentLater"
                        className="custom-radio-input-wire-transfer"
                    >
                        <p className="bank-text">
                            <Text t="selectABankToPayWithInstantTransfer" />
                        </p>

                        <div className="other-banks-content">
                            {currentBank === 'paymentLater' && (
                                <div className="other-banks-list-content">
                                    <div className="other-banks-list">
                                        {bankList?.map((item) => (
                                            <div className="info-box" data-text={copiedText} key={item.id}>
                                                {item?.image && (
                                                    <span className="template-logo">
                                                        <CustomImage src={`data:image/jpeg;base64,` + item?.image} />
                                                    </span>
                                                )}

                                                <div className="info-item">
                                                    <span className="title">
                                                        <Text t="bankName2" />
                                                    </span>
                                                    <span className="description">{item.name}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="title">
                                                        <Text t="branchCode2" />
                                                    </span>
                                                    <span className="description">{item.branchCode}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="title">
                                                        <Text t="branchName2" />
                                                    </span>
                                                    <span className="description">{item.branchName}</span>
                                                </div>

                                                <div className="info-item">
                                                    <span className="title">
                                                        <Text t="accountNo2" />
                                                    </span>
                                                    <span className="description">{item?.accountNumber}</span>
                                                </div>

                                                <div className="info-item">
                                                    <span className="title">
                                                        <Text t="recipientName2" />
                                                    </span>
                                                    <span className="description">
                                                        <Text t="edenredKurumsalCozumlerAS" />
                                                    </span>
                                                </div>

                                                <div className="info-item info-bank">
                                                    <span className="title">
                                                        <Text t="iban" />
                                                    </span>
                                                    <div>
                                                        <span className="description">{item.iban}</span>
                                                    </div>
                                                </div>
                                                <div className="info-item">
                                                    <span className="title">&nbsp;</span>
                                                    <span className="description">
                                                        <button
                                                            type="button"
                                                            className="copy-btn"
                                                            onClick={(e) => onClickCopy(e, item.iban)}
                                                        >
                                                            <Text t={copyText} />
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </Radio.Group>
                </div>
            </div>
        </>
    );
};

EftWireTransferCardsUI.propTypes = {
    finishPage: PropTypes.bool,
    type: PropTypes.string,
    onContinue: PropTypes.func,
};

export default EftWireTransferCardsUI;
